import {LambdaClient} from '@aws-sdk/client-lambda'
import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";
import { CognitoIdentityClient } from "@aws-sdk/client-cognito-identity";

const REGION = "ap-southeast-2";
const IDENTITY_POOL_ID = "ap-southeast-2:82d963d5-6eff-45c0-8a54-672e4206e75c";

// Create an AWS Lambda client service object that initializes the Amazon Cognito credentials provider.
const lambdaClient = new LambdaClient({
  region: REGION,
  credentials: fromCognitoIdentityPool({
    client: new CognitoIdentityClient({ region: REGION }),
    identityPoolId: IDENTITY_POOL_ID
  }),
});

export default lambdaClient